import { render, staticRenderFns } from "./MotivoFormTpl.vue?vue&type=template&id=2646c3e4&"
import script from "./MotivoFormTpl.vue?vue&type=script&lang=js&"
export * from "./MotivoFormTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2646c3e4')) {
      api.createRecord('2646c3e4', component.options)
    } else {
      api.reload('2646c3e4', component.options)
    }
    module.hot.accept("./MotivoFormTpl.vue?vue&type=template&id=2646c3e4&", function () {
      api.rerender('2646c3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lista-vez/MotivoFormTpl.vue"
export default component.exports